import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CouponPage.css';

function CouponCard({ coupon }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(coupon.code);
    alert('Coupon code copied!');
  };

  return (
    <div className={`cp-ticket cp-ticket--${coupon.theme}`}>
      <div className="cp-ticket-top">
        <div className={`cp-ticket-icon cp-ticket-icon--${coupon.theme}`}>
          {coupon.icon}
        </div>
        <p className="cp-ticket-type">{coupon.type}</p>
        <p className="cp-ticket-name">{coupon.name}</p>
      </div>

      <div className="cp-ticket-tear">
        <div className="cp-tear-notch cp-tear-notch--left" />
        <div className="cp-tear-dash" />
        <div className="cp-tear-notch cp-tear-notch--right" />
      </div>

      <div className="cp-ticket-bottom">
        <p className="cp-code-label">Coupon Code</p>

        <div className="cp-code-row">
          <span className="cp-code-val">
            {coupon.code || "Loading..."}
          </span>

          <button
            className={`cp-copy-btn cp-copy-btn--${coupon.theme}`}
            onClick={handleCopy}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          </button>
        </div>

        <div className="cp-validity">
          <svg
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>Until {coupon.validUntil}</span>
        </div>

        <button
          className={`cp-redeem-btn cp-redeem-btn--${coupon.theme}`}
          onClick={() => window.open(coupon.link, "_blank")}
        >
          Redeem on 1mg
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </button>
      </div>
    </div>
  );
}

const CouponPage = () => {
  const navigate = useNavigate();

  const [couponData, setCouponData] = useState({
    coupon1: "",
    coupon2: "",
  });

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const pnid = localStorage.getItem("pnid");

      if (!pnid) {
        console.error("PNID not found in localStorage");
        return;
      }

      const response = await fetch("https://backend-coupon-distribution-nhf.onrender.com/get-coupons", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pnid }),
      });

      const data = await response.json();

      if (data.success) {
        setCouponData({
          coupon1: data.coupon1,
          coupon2: data.coupon2,
        });
      } else {
        console.error(data.error);
      }
    } catch (err) {
      console.error("Error fetching coupons:", err);
    }
  };

  const COUPONS = [
    {
      key: "test",
      type: "Test Coupon",
      name: "Vitamin D Test",
      code: couponData.coupon1,
      validUntil: "May 30, 2026",
      link:
        "https://www.1mg.com/otc/deksel-oral-nano-liquid-60000-iu-5ml-each-sugar-free-otc634337",
      theme: "teal",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" />
        </svg>
      ),
    },
    {
      key: "supplement",
      type: "Supplement Coupon",
      name: "Vitamin D Supplement",
      code: couponData.coupon2,
      validUntil: "Jun 30, 2026",
      link: "https://www.1mg.com",
      theme: "purple",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" />
          <path d="m8.5 8.5 7 7" />
        </svg>
      ),
    },
  ];

  return (
    <div className="cp-root">
      <div className="cp-container fade-in-up">
        <button
          className="cp-back"
          onClick={() => navigate("/dashboard")}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Back
        </button>

        <div className="cp-header">
          <h1 className="cp-title">Your Coupons</h1>
          <p className="cp-subtitle">Exclusive offers from Nutrihealth</p>
        </div>

        <div className="cp-grid">
          {COUPONS.map((coupon) => (
            <CouponCard key={coupon.key} coupon={coupon} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CouponPage;